import { render, staticRenderFns } from "./Searchtrader.vue?vue&type=template&id=5d1df7f4"
import script from "./Searchtrader.vue?vue&type=script&lang=js"
export * from "./Searchtrader.vue?vue&type=script&lang=js"
import style0 from "./Searchtrader.vue?vue&type=style&index=0&id=5d1df7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports